import React from "react";
import './FooterAll.css';
import ico_gurs from '../../../static/img/ico_gurs.png';
import TwitterLogo from "../../../static/img/Header/twitter.svg";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
import MainMenuArray from "../MainMenu";

const SubMenuWork = (Submenu,lang) => { // Правила по которым создается новый массив при окончании перемещения элементов мышкой
    const result = Array.from(Submenu);
    return result.map(function(SubMenuElement,index) {
        return (
            <ChangeLink lang={lang} key={index} to={SubMenuElement.href} style={{textDecoration: 'none'}}><div className="footer_element">{SubMenuElement.Name[lang]}</div></ChangeLink>
        )});};

const topFooterMenu = (lang) => MainMenuArray.map(function(MenuElement,index) {
    return (
        <div key={index}  className="footer_column_1">
            <ChangeLink lang={lang} to={MenuElement.href} style={{textDecoration: 'none'}}><span className="footer_title">{MenuElement.Name[lang]}</span></ChangeLink>
            {SubMenuWork(MenuElement.Submenu,lang)}
        </div>
    )}

);

function FooterAll(props) {
    //console.log('props.data FooterAll',props.data);
    let ThisYear = new Date();
    return (
        <footer className="FooterAll">
            <div className="FooterAllIn">
            <div className="footerTop">
                <div className="footer_logo">© 2015—{ThisYear.getFullYear()} FXBitcoin</div>
                <div className="FooterTwitter"><a href="https://twitter.com/FXBitcoin4" target='_blank' rel="noopener noreferrer" ><img src={TwitterLogo}  alt='Ifyoudontseeimages' height='36px'/></a></div>

                <div className="footer_gurs">
                    <div><a href="http://gurs-fx.com/" target='_blank' rel="noopener noreferrer" ><img  alt='alt' src={ico_gurs}/></a></div>
                    <div>Protected GURS (Global Unite Responsibility System)</div>
                </div>
            </div>
            <div className="footer_links">
                {topFooterMenu(props.lang)}
            </div>
            </div>

        </footer>
    )}



export default FooterAll


